const reportSources = {
  WRITE_PROMPT: "WritePrompt",
  ARTICLE_TOPICS: "ArticleTopics",
  KEY_TERM: "KeyTerm",
  CHECKS_FOR_UNDERSTANDING: "ChecksForUnderstanding",
  GUIDED_HIGHLIGHTING_QUESTION: "GuidedHighlightingQuestion",
  TRANSLATE: "Translate",
  AI_LEVELER: "AiLeveler",
  LESSON_PLANNER: "LessonPlanner",
  TEACHER_TOOLS: "TeacherTools",
} as const;

export type ReportSource = (typeof reportSources)[keyof typeof reportSources];

export default reportSources;
